import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createAdmin = (params) => {
  return Api(endPoints.createAdmin, params, requestType.POST);
};

const loginAdmin = (params) => {
  return Api(endPoints.loginAdmin, params, requestType.POST);
};

const changePasswordAdmin = (params) => {
  return Api(endPoints.changePasswordAdmin, params, requestType.POST);
};

const updateProfileAdmin = (id, params) => {
  return Api(`${endPoints.updateProfileAdmin}/${id}`, params, requestType.PUT);
};

export { createAdmin, loginAdmin, changePasswordAdmin, updateProfileAdmin };
